// error
// login
export const ERROR_ACCOUNT_NOT_FILL = '請填寫電郵或電話'
export const ERROR_PASSWORD_NOT_FILL = '請填寫密碼'
export const ERROR_ACCOUNT_PASSWORD_ERROR = '帳户或密碼錯誤'

// reg
export const ERROR_EMAIL_NOT_FILL = '請填寫電郵'
export const ERROR_EMAIL_VCODE_NOT_FILL = '請填寫電郵驗證碼'
export const ERROR_PHONE_NOT_FILL = '請填寫電話'
export const ERROR_PASSWORD_CONFIRM_NOT_FILL = '請填寫確認密碼'
export const ERROR_PWD_NOT_SAME = '兩次密碼唔一致'